import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { formatApiErrorDetail } from '../lib/api';

export default function Register() {
  const navigate = useNavigate();
  const { register } = useAuth();
  const [name, setName] = useState('');
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleRegister = async () => {
    setError('');
    if (password !== confirm) {
      return setError('Passwords do not match');
    }
    setLoading(true);
    try {
      await register({ name, username, email, password });
      navigate('/login');
    } catch (err) {
      setError(formatApiErrorDetail(err?.response?.data?.detail) || err.message || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full bg-[#0d1117] border border-gray-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-orange-500";

  return (
    <div className="min-h-screen bg-[#0d1117] flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-[#161b22] p-8 rounded-2xl border border-gray-800 shadow-2xl">
        <h2 className="text-2xl font-bold text-white mb-6 text-center">Create an Account</h2>
        {error && <div className="bg-red-500/10 text-red-500 p-3 rounded mb-4 text-sm">{error}</div>}
        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-1 w-full">
            <label className="text-sm text-gray-400">Name (Optional)</label>
            <input type="text" value={name} onChange={(e) => setName(e.target.value)} className={inputCls} />
          </div>
          <div className="flex flex-col gap-1 w-full">
            <label className="text-sm text-gray-400">Username</label>
            <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} className={inputCls} />
          </div>
          <div className="flex flex-col gap-1 w-full">
            <label className="text-sm text-gray-400">Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} />
          </div>
          <div className="flex flex-col gap-1 w-full">
            <label className="text-sm text-gray-400">Password</label>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <input type={showPassword ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} />
              <button type="button" onClick={() => setShowPassword(!showPassword)} className="text-blue-500 text-sm whitespace-nowrap">
                {showPassword ? "Hide" : "Show"}
              </button>
            </div>
          </div>
          <div className="flex flex-col gap-1 w-full">
            <label className="text-sm text-gray-400">Confirm Password</label>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <input type={showConfirm ? "text" : "password"} value={confirm} onChange={(e) => setConfirm(e.target.value)} className={inputCls} />
              <button type="button" onClick={() => setShowConfirm(!showConfirm)} className="text-blue-500 text-sm whitespace-nowrap">
                {showConfirm ? "Hide" : "Show"}
              </button>
            </div>
          </div>
          <button onClick={handleRegister} disabled={loading} className="w-full bg-orange-500 hover:bg-orange-600 text-white font-bold py-3 rounded-lg mt-2 transition-colors disabled:opacity-50">
            {loading ? "Registering..." : "Register"}
          </button>
        </div>
        <p className="text-center text-gray-400 mt-6 text-sm">
          Already have an account? <Link to="/login" className="text-orange-500 hover:underline">Login</Link>
        </p>
      </div>
    </div>
  );
}
